// extracted by mini-css-extract-plugin
module.exports = {"header":"toggleable-section__header___1fWsv"};